import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { Inject } from '@angular/core';

@Component({
  selector: 'app-input-promo-modal',
  templateUrl: './input-promo-modal.component.html',
  styleUrls: ['./input-promo-modal.component.css']
})
export class InputPromoModalComponent implements OnInit {
  promoCodeForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<InputPromoModalComponent>,
    @Inject(MAT_DIALOG_DATA) private params: any
  ) { }

  ngOnInit() {
    this.promoCodeForm = new FormGroup({
      promoCode: new FormControl('', [Validators.required, Validators.minLength(4)])
    });
  }

  applyPromo() {
    this.dialogRef.close(this.promoCodeForm.value.promoCode)
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/reusable/input-promo-modal/input-promo-modal.component.ts